<template>
  <div class="vendors" v-resize="onResizePage">
    <div class="content">

      <div class="wrap">
        <div class="wrap__tree">
          <div class="nav-tree">
            <h3>Vendors</h3>
            <el-dropdown @command="handleCommand">
              <el-button class="nav-tree__item" size="small" type="menu" icon="el-icon-edit-outline">{{$t('project_dropdown_action')}}</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item  v-if="companyLayout" command="addVendor" :disabled="!companyLayout.permission.addVendors" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-plus">{{$t('vendors_btn_add')}}</el-dropdown-item>
                <el-dropdown-item  v-if="companyLayout" command="editVendor" v-show="disabledBtn" :disabled="!companyLayout.permission.updateVendors || selectedRow.type === 'person'" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-edit">{{$t('vendors_btn_edit')}}</el-dropdown-item>
                <el-dropdown-item  v-if="companyLayout" command="activeInactiveVendor" v-show="disabledBtn" :disabled="!companyLayout.permission.updateVendors || true" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-edit">Active/Inactive</el-dropdown-item>
                <el-dropdown-item  v-if="companyLayout" command="deleteVendor" v-show="disabledBtn" :disabled="!companyLayout.permission.deleteVendors || selectedRow.type === 'person'" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-delete">{{$t('vendors_btn_delete')}}</el-dropdown-item>
                <el-dropdown-item  v-if="companyLayout" command="addContact" v-show="disabledBtn"  :disabled="!companyLayout.permission.addVendorsPerson || selectedRow.type === 'person'" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-plus">Add Contact</el-dropdown-item>
                <el-dropdown-item  v-if="companyLayout" command="editContact" v-show="disabledBtn"  :disabled="!companyLayout.permission.updateVendorsPerson || selectedRow.type === 'vendor'" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-edit">Edit Contact</el-dropdown-item>
                <el-dropdown-item  v-if="companyLayout" command="deleteContact" v-show="disabledBtn"  :disabled="!companyLayout.permission.updateVendorsPerson || selectedRow.type === 'vendor'" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-edit">Delete Contact</el-dropdown-item>
                <el-dropdown-item  v-if="companyLayout" command="addToBu" v-show="disabledBtn" :disabled="selectedRow.type === 'person'" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-plus">Add To BU</el-dropdown-item>
                <el-dropdown-item  v-if="companyLayout" command="importVendors" v-show="disabledBtn" :disabled="false"  class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-plus">Import Vendors</el-dropdown-item>
<!--                <el-dropdown-item class="nav-tree__item" command="addContact" size="mini" type="primary" plain icon="el-icon-plus">Add Contact</el-dropdown-item>-->
              </el-dropdown-menu>
            </el-dropdown>
          </div>
            <ag-grid-vue style="width: 100%; height: 96%;" class="ag-theme-balham" id="myGrid"
              :gridOptions="gridOptions"
              @grid-ready="onGridReady"
              :columnDefs="columnDefs"
              :defaultColDef="defaultColDef"
              :getRowHeight="getRowHeight"
              :getDataPath="getDataPath"
              :rowDragManaged="true"
              :animateRows="true"
              :rowData="rowData"
              :floatingFilter="true"
              :rowSelection="rowSelection"
              :suppressMultiSort="false"
              @selection-changed="onSelectionChanged"
              :suppressContextMenu="true"
              :getRowNodeId="getRowNodeId"
              :autoGroupColumnDef="autoGroupColumnDef"
              :groupDefaultExpanded="groupDefaultExpanded"
              :treeData="true"></ag-grid-vue>
        </div>

        <div class="wrap__info">
          <div class="wrap__info-tab">

          <div style="margin-bottom: 10px;">
            <el-dropdown placement="bottom-start">
              <el-button disabled style="margin-right: 20px;" size="small" type="menu" icon="el-icon-edit-outline">{{$t('project_dropdown_function')}}</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('project_dropdown_function_projectBookmark')}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button :disabled="true" style="margin-right: 12px;" class="nav-tree__item" size="small" type="menu2" icon="el-icon-menu">Vendor Calander</el-button>
            <el-button :disabled="true" class="nav-tree__item" size="small" type="menu2" icon="el-icon-menu">Vendor Reports</el-button>
          </div>

            <el-tabs v-model="activeName" disabled type="border-card" @tab-click="handleClick">
              <el-tab-pane :label="$t('vendors_tab_info')" name="info">
                <ul>

                  <el-tabs v-model="detailsVendors">
                    <el-tab-pane label="Details" name="first">

                      <el-tabs v-model="infoVendors">

                        <!-- General -->
                        <el-tab-pane :label="$t('vendors_tab_vendors_general')" name="first">
                          <el-card>
                            <div v-if="this.selectedRow.type === 'vendor'">
                              <el-row :gutter="20">
                                <el-col :span="16" :offset="0">
                                  <li><div :class="{isEmpty: !info.name}" class="wrap__info-tab_label">{{$t('modal_full_name')}}:</div><span v-html="info.name"></span></li>
                                  <li><div :class="{isEmpty: !info.shortName}" class="wrap__info-tab_label">{{$t('modal_short_name')}}:</div><span v-html="info.shortName"></span></li>
                                  <li><div :class="{isEmpty: !info.email}" class="wrap__info-tab_label">{{$t('modal_email')}}:</div> <span v-html="info.email"></span></li>
                                  <li><div :class="{isEmpty: !info.website}" class="wrap__info-tab_label">{{$t('modal_website')}}:</div> <span><a :href="info.website" target="_blank">{{info.website}}</a></span></li>
                                  <li><div :class="{isEmpty: !info.phone}" class="wrap__info-tab_label">{{$t('modal_phone_main')}}:</div><span v-html="info.phone"></span></li>
                                  <li><div :class="{isEmpty: !info.fax}" class="wrap__info-tab_label">{{$t('modal_fax_main')}}:</div><span v-html="info.fax"></span></li>
                                  <li><div :class="{isEmpty: !info.facebook}" class="wrap__info-tab_label">{{$t('modal_facebook')}}:</div> <span><a :href="info.facebook" target="_blank">{{info.facebook}}</a></span></li>
                                  <li><div :class="{isEmpty: !info.linkedIn}" class="wrap__info-tab_label">{{$t('modal_linkedIn')}}:</div> <span><a :href="info.linkedIn" target="_blank">{{info.linkedIn}}</a></span></li>
                                  <li><div :class="{isEmpty: !info.assignSupplyChainMgr}" class="wrap__info-tab_label">{{$t('modal_assign_supply_chain_mgr')}}:</div><span v-html="info.assignSupplyChainMgr"></span></li>
                                  <li><div :class="{isEmpty: !info.shippingMethod}" class="wrap__info-tab_label">{{$t('modal_shipping_method')}}:</div><span v-html="info.shippingMethod"></span></li>
                                  <li><div :class="{isEmpty: !info.tagAs}" class="wrap__info-tab_label">Tag As:</div><span v-html="info.tagAs"></span></li>
                                </el-col>
                                <el-col :span="8" :offset="0">
                                  <h4 style="margin-top: 0px;">Vendor QR</h4>
                                  <qr-code :text="'https://dev.totalflow.io' + this.$route.fullPath" :size="120"></qr-code>
                                  <h4>Vendor ID</h4>
                                  <el-input disabled style="width: 200px;" placeholder="" size="normal" clearable></el-input>
                                </el-col>
                              </el-row>
                            </div>
                            <div v-else>
                              <li><div :class="{isEmpty: !info.primaryContact}" class="wrap__info-tab_label">Primary Contact::</div><span v-html="info.primaryContact ? 'Yes' : 'No'"></span></li>
                              <li><div :class="{isEmpty: !info.firstname}" class="wrap__info-tab_label">{{$t('modal_first_name')}}:</div><span v-html="info.firstname"></span></li>
                              <li><div :class="{isEmpty: !info.lastname}" class="wrap__info-tab_label">{{$t('modal_last_name')}}:</div><span v-html="info.lastname"></span></li>
                              <li><div :class="{isEmpty: !info.email}" class="wrap__info-tab_label">{{$t('modal_email')}}:</div> <span v-html="info.email"></span></li>
                              <li><div :class="{isEmpty: !info.position}" class="wrap__info-tab_label">Position:</div> <span v-html="info.position"></span></li>
                              <li><div :class="{isEmpty: !info.department}" class="wrap__info-tab_label">Department:</div> <span v-html="info.department"></span></li>
                              <li><div :class="{isEmpty: !info.workPhone}" class="wrap__info-tab_label">{{$t('modal_work_phone')}}:</div><span v-html="info.workPhone"></span></li>
                              <li><div :class="{isEmpty: !info.mobilePhone}" class="wrap__info-tab_label">{{$t('modal_phone')}}:</div><span v-html="info.mobilePhone"></span></li>
                              <li><div :class="{isEmpty: !info.skype}" class="wrap__info-tab_label">{{$t('modal_skype')}}:</div><span v-html="info.skype"></span></li>
                              <li><div :class="{isEmpty: !info.linkedIn}" class="wrap__info-tab_label">{{$t('modal_linkedIn')}}:</div> <span><a :href="info.linkedIn" target="_blank">{{info.linkedIn}}</a></span></li>
                              <li><div :class="{isEmpty: !info.facebook}" class="wrap__info-tab_label">{{$t('modal_facebook')}}:</div> <span><a :href="info.facebook" target="_blank">{{info.facebook}}</a></span></li>
                            </div>
                          </el-card>
                        </el-tab-pane>

                        <!-- Addresses -->
                        <el-tab-pane v-if="this.selectedRow.type === 'vendor'" :label="$t('vendors_tab_vendors_addresses')" name="second">
                          <el-card>

                            <el-row :gutter="10">
                              <el-col :span="8" :offset="0" style="min-height: 400px;">
                                <h4 style="margin-top: 0px;">Main Address:</h4>

                                <li><div :class="{isEmpty: !this.info.addresses.mainAddress.country.name}" class="wrap__info-tab_label">{{$t('modal_country')}}:</div><span v-html="this.info.addresses.mainAddress.country.name"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.mainAddress.state.name}" class="wrap__info-tab_label">{{$t('modal_state')}}:</div><span v-html="this.info.addresses.mainAddress.state.name"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.mainAddress.city.name}" class="wrap__info-tab_label">{{$t('modal_city')}}:</div><span v-html="this.info.addresses.mainAddress.city.name"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.mainAddress.postCode}" class="wrap__info-tab_label">{{$t('modal_post_code')}}:</div><span v-html="this.info.addresses.mainAddress.postCode"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.mainAddress.addressLines.addressLine1}" class="wrap__info-tab_label">{{$t('modal_address_line_1')}}:</div><span v-html="this.info.addresses.mainAddress.addressLines.addressLine1"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.mainAddress.addressLines.addressLine2}" class="wrap__info-tab_label">{{$t('modal_address_line_2')}}:</div><span v-html="this.info.addresses.mainAddress.addressLines.addressLine2"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.mainAddress.addressLines.addressLine3}" class="wrap__info-tab_label">{{$t('modal_address_line_3')}}:</div><span v-html="this.info.addresses.mainAddress.addressLines.addressLine3"></span></li>

                                <iframe width="100%" height="200px" id="gmap_canvas" :src="this.map1" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                              </el-col>
                              <el-col :span="8" :offset="0">
                                <h4 style="margin-top: 0px;">Billing Address:</h4>

                                <li><div :class="{isEmpty: !this.info.addresses.billingAddress.country.name}" class="wrap__info-tab_label">{{$t('modal_country')}}:</div><span v-html="this.info.addresses.billingAddress.country.name"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.billingAddress.state.name}" class="wrap__info-tab_label">{{$t('modal_state')}}:</div><span v-html="this.info.addresses.billingAddress.state.name"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.billingAddress.city.name}" class="wrap__info-tab_label">{{$t('modal_city')}}:</div><span v-html="this.info.addresses.billingAddress.city.name"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.billingAddress.postCode}" class="wrap__info-tab_label">{{$t('modal_post_code')}}:</div><span v-html="this.info.addresses.billingAddress.postCode"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.billingAddress.addressLines.addressLine1}" class="wrap__info-tab_label">{{$t('modal_address_line_1')}}:</div><span v-html="this.info.addresses.billingAddress.addressLines.addressLine1"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.billingAddress.addressLines.addressLine2}" class="wrap__info-tab_label">{{$t('modal_address_line_2')}}:</div><span v-html="this.info.addresses.billingAddress.addressLines.addressLine2"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.billingAddress.addressLines.addressLine3}" class="wrap__info-tab_label">{{$t('modal_address_line_3')}}:</div><span v-html="this.info.addresses.billingAddress.addressLines.addressLine3"></span></li>

                                <iframe width="100%" height="200px" id="gmap_canvas" :src="this.map2" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                              </el-col>
                              <el-col :span="8" :offset="0">
                                <h4 style="margin-top: 0px;">Shipping/Warehouse Address:</h4>

                                <li><div :class="{isEmpty: !this.info.addresses.shippingWarehouseAddress.country.name}" class="wrap__info-tab_label">{{$t('modal_country')}}:</div><span v-html="this.info.addresses.shippingWarehouseAddress.country.name"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.shippingWarehouseAddress.state.name}" class="wrap__info-tab_label">{{$t('modal_state')}}:</div><span v-html="this.info.addresses.shippingWarehouseAddress.state.name"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.shippingWarehouseAddress.city.name}" class="wrap__info-tab_label">{{$t('modal_city')}}:</div><span v-html="this.info.addresses.shippingWarehouseAddress.city.name"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.shippingWarehouseAddress.postCode}" class="wrap__info-tab_label">{{$t('modal_post_code')}}:</div><span v-html="this.info.addresses.shippingWarehouseAddress.postCode"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.shippingWarehouseAddress.addressLines.addressLine1}" class="wrap__info-tab_label">{{$t('modal_address_line_1')}}:</div><span v-html="this.info.addresses.shippingWarehouseAddress.addressLines.addressLine1"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.shippingWarehouseAddress.addressLines.addressLine2}" class="wrap__info-tab_label">{{$t('modal_address_line_2')}}:</div><span v-html="this.info.addresses.shippingWarehouseAddress.addressLines.addressLine2"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.shippingWarehouseAddress.addressLines.addressLine3}" class="wrap__info-tab_label">{{$t('modal_address_line_3')}}:</div><span v-html="this.info.addresses.shippingWarehouseAddress.addressLines.addressLine3"></span></li>

                                <iframe width="100%" height="200px" id="gmap_canvas" :src="this.map3" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                              </el-col>
                            </el-row>

                          </el-card>
                        </el-tab-pane>
                        <el-tab-pane v-else :label="$t('vendors_tab_vendors_addresses')" name="second">
                          <el-row :gutter="10">
                            <el-col :span="12" :offset="0" style="min-height: 400px;">

                              <li><div :class="{isEmpty: !this.info.country}" class="wrap__info-tab_label">{{$t('modal_country')}}:</div><span v-html="this.info.country ? this.info.country.name : ''"></span></li>
                              <li><div :class="{isEmpty: !this.info.state}" class="wrap__info-tab_label">{{$t('modal_state')}}:</div><span v-html="this.info.state ? this.info.state.name : ''"></span></li>
                              <li><div :class="{isEmpty: !this.info.city}" class="wrap__info-tab_label">{{$t('modal_city')}}:</div><span v-html="this.info.city ? this.info.city.name : ''"></span></li>
                              <li><div :class="{isEmpty: !this.info.postCode}" class="wrap__info-tab_label">{{$t('modal_post_code')}}:</div><span v-html="this.info.postCode"></span></li>
                              <li><div :class="{isEmpty: !this.info.address}" class="wrap__info-tab_label">{{$t('modal_address_line_1')}}:</div><span v-html="this.info.address"></span></li>
                              <li><div :class="{isEmpty: !this.info.address2}" class="wrap__info-tab_label">{{$t('modal_address_line_2')}}:</div><span v-html="this.info.address2"></span></li>
                              <li><div :class="{isEmpty: !this.info.address3}" class="wrap__info-tab_label">{{$t('modal_address_line_3')}}:</div><span v-html="this.info.address3"></span></li>

                              <iframe width="100%" height="200px" id="gmap_canvas" :src="this.map" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                            </el-col>
                            <el-col :span="12" :offset="0">

                            </el-col>
                          </el-row>
                        </el-tab-pane>

                        <!-- Finance -->
                        <el-tab-pane v-if="this.selectedRow.type === 'vendor'" :label="$t('vendors_tab_vendors_finance')" name="third">
                          <el-card>
                            <el-row :gutter="20">
                              <el-col :span="8">
                                <h4 style="margin-top: 0px;">{{$t('modal_title_general')}}:</h4>
                              </el-col>
                              <el-col :span="16">
                                <h4 style="margin-top: 0px;">{{$t('modal_title_bank_details')}}:</h4>
                              </el-col>
                            </el-row>

                            <el-row :gutter="20">
                              <el-col :span="8">
                                <li><div :class="{isEmpty: !this.info.finance.currency}" class="wrap__info-tab_label">{{$t('modal_currency')}}:</div><span v-html="this.info.finance.currency ? this.info.finance.currency.name : null"></span></li>
                                <li><div :class="{isEmpty: !this.info.finance.creditLimit}" class="wrap__info-tab_label">{{$t('modal_credit_limit')}}:</div><span>{{formatPrice(this.info.finance.creditLimit)}}</span></li>
                                <li><div :class="{isEmpty: !this.info.finance.paymentTerms}" class="wrap__info-tab_label">{{$t('modal_payment_terms')}}:</div><span v-html="this.info.finance.paymentTerms ? this.info.finance.paymentTerms.name : null"></span></li>
                                <li><div :class="{isEmpty: !this.info.finance.paymentTypes}" class="wrap__info-tab_label">{{$t('modal_payment_types')}}:</div><span v-html="this.info.finance.paymentTypes ? this.info.finance.paymentTypes.name : null"></span></li>
                              </el-col>
                              <el-col :span="16">
                                <li><div :class="{isEmpty: !this.info.finance.bankName}" class="wrap__info-tab_label">{{$t('modal_bank_name')}}:</div><span v-html="this.info.finance.bankName"></span></li>
                                <li><div :class="{isEmpty: !this.info.addresses.bankAddress}" class="wrap__info-tab_label">{{$t('modal_bank_address')}}:</div><span v-if="this.info.addresses.bankAddress">{{this.info.addresses.bankAddress.country.name}} {{`, ${this.info.addresses.bankAddress.state.name}`}} {{`, ${this.info.addresses.bankAddress.city.name}`}} {{`, ${this.info.addresses.bankAddress.postCode}`}} {{`, ${this.info.addresses.bankAddress.addressLines.addressLine1}`}} {{`, ${this.info.addresses.bankAddress.addressLines.addressLine2}`}} {{`, ${this.info.addresses.bankAddress.addressLines.addressLine3}`}}</span></li>
                                <li><div :class="{isEmpty: !this.info.finance.SWIFTCode}" class="wrap__info-tab_label">{{$t('modal_SWIFT_code')}}:</div><span v-html="this.info.finance.SWIFTCode"></span></li>
                                <li><div :class="{isEmpty: !this.info.finance.accountName}" class="wrap__info-tab_label">{{$t('modal_account_name')}}:</div><span v-html="this.info.finance.accountName"></span></li>
                                <li><div :class="{isEmpty: !this.info.finance.branchSortCode}" class="wrap__info-tab_label">{{$t('modal_account_branch')}}:</div><span v-html="this.info.finance.branchSortCode"></span></li>
                                <li><div :class="{isEmpty: !this.info.finance.accountIBANNo}" class="wrap__info-tab_label">{{$t('modal_account_account')}}:</div><span v-html="this.info.finance.accountIBANNo"></span></li>
                              </el-col>
                            </el-row>
                          </el-card>
                        </el-tab-pane>

                        <!-- Canvass -->
                        <el-tab-pane v-if="this.selectedRow.type === 'vendor'" :label="$t('vendors_tab_vendors_canvass')" name="fourth">
                          <el-card>
                            <li><div :class="{isEmpty: !this.info.canvas.ISOAccreditationNo}" class="wrap__info-tab_label">{{$t('modal_iso')}}:</div><span v-html="this.info.canvas.ISOAccreditationNo"></span></li>
                            <li><div :class="{isEmpty: !this.info.canvas.canvassSheetId}" class="wrap__info-tab_label">{{$t('modal_canvass_sheet')}}:</div><span v-html="this.info.canvas.canvassSheetId"></span></li>
                            <li><div :class="{isEmpty: !this.info.canvas.formsId}" class="wrap__info-tab_label">{{$t('modal_forms')}}:</div><span v-html="this.info.canvas.formsId"></span></li>
                          </el-card>
                        </el-tab-pane>

                        <!-- Custom -->
                        <el-tab-pane v-if="this.selectedRow.type === 'vendor'" :label="$t('vendors_tab_vendors_custom')" name="fifth">
                          <el-card>
                            <li><div :class="{isEmpty: !this.info.custom.customField1}" class="wrap__info-tab_label">{{$t('modal_custom_field_1')}}:</div><span v-html="this.info.custom.customField1"></span></li>
                            <li><div :class="{isEmpty: !this.info.custom.customField2}" class="wrap__info-tab_label">{{$t('modal_custom_field_2')}}:</div><span v-html="this.info.custom.customField2"></span></li>
                            <li><div :class="{isEmpty: !this.info.custom.customField3}" class="wrap__info-tab_label">{{$t('modal_custom_field_3')}}:</div><span v-html="this.info.custom.customField3"></span></li>
                            <li><div :class="{isEmpty: !this.info.custom.customField4}" class="wrap__info-tab_label">{{$t('modal_custom_field_4')}}:</div><span v-html="this.info.custom.customField4"></span></li>
                            <li><div :class="{isEmpty: !this.info.custom.customField5}" class="wrap__info-tab_label">{{$t('modal_custom_field_5')}}:</div><span v-html="this.info.custom.customField5"></span></li>
                            <li><div :class="{isEmpty: !this.info.custom.customField6}" class="wrap__info-tab_label">{{$t('modal_custom_field_6')}}:</div><span v-html="this.info.custom.customField6"></span></li>
                          </el-card>
                        </el-tab-pane>

                        <!-- Tax Settings -->
                        <el-tab-pane v-if="this.selectedRow.type === 'vendor'" label="Tax Settings" name="settings">
                          <el-card v-if="this.info.tax">
                            <el-row :gutter="20">
                              <el-col :span="11">
                                <li><div :class="{isEmpty: !this.info.tax.serviceOrProduct}" class="wrap__info-tab_label">{{$t('modal_product_or_service')}}:</div><span v-html="this.info.tax.serviceOrProduct ? this.info.tax.serviceOrProduct.name : null"></span></li>
                                <li><div :class="{isEmpty: !this.info.tax.saleTax}" class="wrap__info-tab_label">{{$t('modal_tax_type_vat')}}:</div><span v-html="this.info.tax.saleTax ? this.info.tax.saleTax.name : null"></span></li>
                                <li><div :class="{isEmpty: !this.info.tax.saleTax}" class="wrap__info-tab_label">Tax Code (VAT):</div><span v-html="this.info.tax.saleTax ? this.info.tax.saleTax.code : null"></span></li>
                                <li><div class="wrap__info-tab_label">Apply Withholding Tax:</div><span v-html="(this.info.tax.productWithholdingTax || this.info.tax.serviceWithholdingTax) ? 'Yes' : 'No'"></span></li>
                                <li><div :class="{isEmpty: !this.info.tax.productWithholdingTax}" class="wrap__info-tab_label">Tax Type (WHT) Product:</div><span v-html="this.info.tax.productWithholdingTax ? this.info.tax.productWithholdingTax.name : null"></span></li>
                                <li><div :class="{isEmpty: !this.info.tax.serviceWithholdingTax}" class="wrap__info-tab_label">Tax Type (WHT) Service:</div><span v-html="this.info.tax.serviceWithholdingTax ? this.info.tax.serviceWithholdingTax.name : null"></span></li>
                              </el-col>
                              <el-col :span="13">
                                <li><div class="wrap__info-tab_label">Withhold Expanded VAT:</div><span v-html="this.info.tax.clientWithholding ? 'Yes' : 'No'"></span></li>
                                <li v-if="this.info.tax.clientWithholding"><div class="wrap__info-tab_label">Tax Type (VAT):</div><span v-text="this.info.tax.clientWithholdingTax.name"></span></li>
                                <li v-if="this.info.tax.clientWithholding"><div class="wrap__info-tab_label">Tax Code (VAT):</div><span v-text="this.info.tax.clientWithholdingTax.code"></span></li>
                              </el-col>
                            </el-row>
                          </el-card>
                        </el-tab-pane>

                        <!-- Expanded -->
                        <el-tab-pane v-if="this.selectedRow.type === 'vendor' && this.info.enableExpanded" :label="$t('vendors_tab_vendors_expanded')" name="sixth">
                          <el-card>
                            <el-row :gutter="20">
                              <el-col :span="11">
                                <h4 style="margin-top: 0px;">{{$t('modal_title_general')}}</h4>
                              </el-col>
                              <el-col :span="13">
                                <h4 style="margin-top: 0px;">{{$t('modal_title_tax_compliance')}}</h4>
                              </el-col>
                            </el-row>

                            <el-row :gutter="20">
                              <el-col :span="11">
                                <li><div :class="{isEmpty: !this.info.expanded.general.country}" class="wrap__info-tab_label">{{$t('modal_country')}}:</div><span v-html="this.info.expanded.general.country ? this.info.expanded.general.country.name : null"></span></li>
                                <li v-if="this.info.expanded.general.registrationBodyId === 1"><div class="wrap__info-tab_label">Registration Body:</div><span>Department of Trade & Industry</span></li>
                                <li v-if="this.info.expanded.general.registrationBodyId === 2"><div class="wrap__info-tab_label">Registration Body:</div><span>Security & Exchange Commission</span></li>
                                <li v-if="this.info.expanded.general.registrationBodyId === 3"><div class="wrap__info-tab_label">Registration Body:</div><span>Cooperative Development Authority</span></li>
                                <li><div :class="{isEmpty: !this.info.expanded.general.industryTypeId}" class="wrap__info-tab_label">Industry Type:</div><span v-html="this.info.expanded.general.industryType ? this.info.expanded.general.industryType.name : null"></span></li>
                                <li><div :class="{isEmpty: !this.info.expanded.general.categoryOfClientId}" class="wrap__info-tab_label">Category Of Client:</div><span v-html="this.info.expanded.general.categoryOfClient ? this.info.expanded.general.categoryOfClient.name : null"></span></li>
                                <li v-if="this.info.expanded.general.registrationBodyId !== 1"><div :class="{isEmpty: !this.info.expanded.general.companyName}" class="wrap__info-tab_label">{{$t('modal_company_name')}}:</div><span v-html="this.info.expanded.general.companyName"></span></li>
                                <li v-if="this.info.expanded.general.registrationBodyId === 1"><div :class="{isEmpty: !this.info.expanded.general.firstName}" class="wrap__info-tab_label">First Name:</div><span v-html="this.info.expanded.general.firstName"></span></li>
                                <li v-if="this.info.expanded.general.registrationBodyId === 1"><div :class="{isEmpty: !this.info.expanded.general.middleName}" class="wrap__info-tab_label">Middle Name:</div><span v-html="this.info.expanded.general.middleName"></span></li>
                                <li v-if="this.info.expanded.general.registrationBodyId === 1"><div :class="{isEmpty: !this.info.expanded.general.surname}" class="wrap__info-tab_label">Surname:</div><span v-html="this.info.expanded.general.surname"></span></li>
                                <li><div :class="{isEmpty: !this.info.expanded.general.tradeName}" class="wrap__info-tab_label">Trade Name:</div><span v-html="this.info.expanded.general.tradeName"></span></li>
                                <li v-if="this.info.expanded.general.registrationBodyId === 1"><div :class="{isEmpty: !this.info.expanded.general.osca}" class="wrap__info-tab_label">Office for Senior Citizens Affairs (OSCA):</div><span v-html="this.info.expanded.general.osca"></span></li>
                                <li v-if="this.info.expanded.general.registrationBodyId === 1"><div :class="{isEmpty: !this.info.expanded.general.pwd}" class="wrap__info-tab_label">Person with Disabilities (PWD):</div><span v-html="this.info.expanded.general.pwd"></span></li>
                                <li><div :class="{isEmpty: !this.info.expanded.general.registrationSECNo}" class="wrap__info-tab_label">{{$t('modal_sec')}}:</div><span v-html="this.info.expanded.general.registrationSECNo"></span></li>
                                <li><div :class="{isEmpty: !this.info.expanded.general.rdo}" class="wrap__info-tab_label">{{$t('modal_rdo')}}:</div><span v-html="this.info.expanded.general.rdo ? this.info.expanded.general.rdo.name : null"></span></li>
                                <li><div :class="{isEmpty: !this.info.expanded.general.barangay}" class="wrap__info-tab_label">Barangay:</div><span v-html="this.info.expanded.general.barangay"></span></li>
                              </el-col>
                              <el-col :span="13">
                                <li><div :class="{isEmpty: !this.info.expanded.compliance.taxClassification}" class="wrap__info-tab_label">{{$t('modal_tax_classification')}}:</div><span v-html="this.info.expanded.compliance.taxClassification ? this.info.expanded.compliance.taxClassification.name : null"></span></li>
                                <li v-if="!this.info.expanded.compliance.occupationId"><div :class="{isEmpty: !this.info.expanded.compliance.lineOfBusiness}" class="wrap__info-tab_label">Line of Business (PSIC):</div><span v-html="this.info.expanded.compliance.lineOfBusiness ? this.info.expanded.compliance.lineOfBusiness.name : null"></span></li>
                                <li v-else><div :class="{isEmpty: !this.info.expanded.compliance.occupation}" class="wrap__info-tab_label">Occupation (PSOC):</div><span v-html="this.info.expanded.compliance.occupation ? this.info.expanded.compliance.occupation.name : null"></span></li>
                                <li><div :class="{isEmpty: !this.info.expanded.compliance.taxIdentificationNo}" class="wrap__info-tab_label">{{$t('modal_tin')}}:</div><span v-html="this.info.expanded.compliance.taxIdentificationNo"></span></li>
                              </el-col>
                            </el-row>
                          </el-card>
                        </el-tab-pane>

                      </el-tabs>

                    </el-tab-pane>
                    <el-tab-pane disabled label="About" name="about"></el-tab-pane>
                    <el-tab-pane disabled label="History" name="history"></el-tab-pane>
                    <el-tab-pane disabled label="Items" name="items"></el-tab-pane>
                    <!-- BU -->
                    <el-tab-pane v-if="this.selectedRow.type === 'vendor'" :label="$t('vendors_tab_bu')" name="businessUnit">
                      <el-tabs activeName="first">
                        <el-tab-pane :label="$t('vendors_tab_bu_first')" name="first">
                          <el-card>
                            <div>
                              <el-table
                                :data="businessUnitList"
                                style="width: 100%">
                                <el-table-column
                                  prop="no"
                                  label="BU No."
                                  width="90">
                                  <template slot-scope="scope">
                                    <el-button
                                      @click.native.prevent="linkBU(businessUnitList[scope.$index].id)"
                                      type="text"
                                      size="small">
                                      {{businessUnitList[scope.$index].code}}
                                    </el-button>
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  prop="name"
                                  label="BU Name">
                                  <template slot-scope="scope">
                                    {{businessUnitList[scope.$index].name}}
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  label="Create Date"
                                  width="100">
                                  <template slot-scope="scope">
                                    {{moment(scope.row.createDate * 1000).format("D MMM YY")}}
                                  </template>
                                </el-table-column>
                              </el-table>
                            </div>
                          </el-card>
                        </el-tab-pane>
                      </el-tabs>
                    </el-tab-pane>
                    <el-tab-pane v-else :label="$t('vendors_tab_bu')" name="businessUnit">
                      <el-tabs activeName="first">
                        <el-tab-pane :label="$t('vendors_tab_bu_first')" name="first">
                          <el-card>
                            <div>
                              <el-table
                                :data="businessUnitList"
                                style="width: 100%">
                                <el-table-column
                                  prop="no"
                                  label="BU No."
                                  width="90">
                                  <template slot-scope="scope">
                                    <el-button
                                      @click.native.prevent="linkBU(businessUnitList[scope.$index].businessUnit.id)"
                                      type="text"
                                      size="small">
                                      {{businessUnitList[scope.$index].businessUnit.code}}
                                    </el-button>
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  prop="name"
                                  label="BU Name">
                                  <template slot-scope="scope">
                                    {{businessUnitList[scope.$index].businessUnit.name}}
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  prop="name"
                                  label="BU Task Name">
                                  <template slot-scope="scope">
                                    <el-button
                                      @click.native.prevent="linkBUTask(businessUnitList[scope.$index].businessUnit.id, businessUnitList[scope.$index].id)"
                                      type="text"
                                      size="small">
                                      {{businessUnitList[scope.$index].name}}
                                    </el-button>
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  label="Create Date"
                                  width="100">
                                  <template slot-scope="scope">
                                    {{moment(scope.row.createDate * 1000).format("D MMM YY")}}
                                  </template>
                                </el-table-column>
                              </el-table>
                            </div>
                          </el-card>
                        </el-tab-pane>
                      </el-tabs>
                    </el-tab-pane>
                    <!-- <el-tab-pane disabled label="Warehouses" name="warehouses"></el-tab-pane> -->
                    <!-- E -->
                    <el-tab-pane v-if="this.selectedRow.type === 'vendor'" :label="$t('vendors_tab_e')" name="engagement">
                      <el-tabs activeName="first">
                        <el-tab-pane :label="$t('vendors_tab_e_first')" name="first">
                          <el-card>
                            <div>
                              <el-table
                                :data="engagementList"
                                style="width: 100%">
                                <el-table-column
                                  prop="no"
                                  label="ENG No."
                                  width="90">
                                  <template slot-scope="scope">
                                    <el-button
                                      @click.native.prevent="linkE(engagementList[scope.$index].id)"
                                      type="text"
                                      size="small">
                                      {{engagementList[scope.$index].code}}
                                    </el-button>
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  prop="name"
                                  label="ENG Name">
                                  <template slot-scope="scope">
                                    {{engagementList[scope.$index].name}}
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  label="Create Date"
                                  width="100">
                                  <template slot-scope="scope">
                                    {{moment(scope.row.createDate * 1000).format("D MMM YY")}}
                                  </template>
                                </el-table-column>
                              </el-table>
                            </div>
                          </el-card>
                        </el-tab-pane>
                      </el-tabs>
                    </el-tab-pane>
                    <el-tab-pane v-else :label="$t('vendors_tab_e')" name="engagement">
                      <el-tabs activeName="first">
                        <el-tab-pane :label="$t('vendors_tab_e_first')" name="first">
                          <el-card>
                            <div>
                              <el-table
                                :data="engagementList"
                                style="width: 100%">
                                <el-table-column
                                  prop="no"
                                  label="ENG No."
                                  width="90">
                                  <template slot-scope="scope">
                                    <el-button
                                      @click.native.prevent="linkE(engagementList[scope.$index].engagement.id)"
                                      type="text"
                                      size="small">
                                      {{engagementList[scope.$index].engagement.code}}
                                    </el-button>
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  prop="name"
                                  label="ENG Name">
                                  <template slot-scope="scope">
                                    {{engagementList[scope.$index].engagement.name}}
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  prop="name"
                                  label="ENG Task Name">
                                  <template slot-scope="scope">
                                    <el-button
                                      @click.native.prevent="linkETask(engagementList[scope.$index].engagement.id, engagementList[scope.$index].id)"
                                      type="text"
                                      size="small">
                                      {{engagementList[scope.$index].name}}
                                    </el-button>
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  label="Create Date"
                                  width="100">
                                  <template slot-scope="scope">
                                    {{moment(scope.row.createDate * 1000).format("D MMM YY")}}
                                  </template>
                                </el-table-column>
                              </el-table>
                            </div>
                          </el-card>
                        </el-tab-pane>
                      </el-tabs>
                    </el-tab-pane>
                    <!-- P -->
                    <el-tab-pane v-if="this.selectedRow.type === 'vendor'" :label="$t('vendors_tab_project')" name="projects">
                      <el-tabs activeName="first">
                        <el-tab-pane :label="$t('vendors_tab_project_first')" name="first">
                          <el-card>
                            <div>
                              <el-table
                                :data="projectList"
                                style="width: 100%">
                                <el-table-column
                                  prop="no"
                                  label="PRO No."
                                  width="90">
                                  <template slot-scope="scope">
                                    <el-button
                                      @click.native.prevent="link(projectList[scope.$index].id)"
                                      type="text"
                                      size="small">
                                      {{projectList[scope.$index].no}}
                                    </el-button>
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  label="PRO Name">
                                  <template slot-scope="scope">
                                    {{projectList[scope.$index].name}}
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  label="Create Date"
                                  width="100">
                                  <template slot-scope="scope">
                                    {{moment(scope.row.createDate * 1000).format("D MMM YY")}}
                                  </template>
                                </el-table-column>
                              </el-table>
                            </div>
                          </el-card>
                        </el-tab-pane>
                      </el-tabs>
                    </el-tab-pane>
                    <el-tab-pane v-else :label="$t('vendors_tab_project')" name="projects">
                      <el-tabs activeName="first">
                        <el-tab-pane :label="$t('vendors_tab_project_first')" name="first">
                          <el-card>
                            <div>
                              <el-table
                                :data="projectList"
                                style="width: 100%">
                                <el-table-column
                                  prop="no"
                                  label="PRO No."
                                  width="90">
                                  <template slot-scope="scope">
                                    <el-button
                                      @click.native.prevent="link(projectList[scope.$index].project.id)"
                                      type="text"
                                      size="small">
                                      {{projectList[scope.$index].project.no}}
                                    </el-button>
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  label="PRO Name">
                                  <template slot-scope="scope">
                                    {{projectList[scope.$index].project.name}}
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  label="PRO Task Name">
                                  <template slot-scope="scope">
                                    <el-button
                                      @click.native.prevent="linkTask(projectList[scope.$index].project.id, projectList[scope.$index].id)"
                                      type="text"
                                      size="small">
                                      {{projectList[scope.$index].name}}
                                    </el-button>
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  label="Create Date"
                                  width="100">
                                  <template slot-scope="scope">
                                    {{moment(scope.row.createDate * 1000).format("D MMM YY")}}
                                  </template>
                                </el-table-column>
                              </el-table>
                            </div>
                          </el-card>
                        </el-tab-pane>
                      </el-tabs>
                    </el-tab-pane>
                  </el-tabs>

                </ul>
              </el-tab-pane>
              <el-tab-pane v-if="selectedRow.type === 'vendor'" :label="$t('vendors_tab_files')" name="vendorFiles">
                <vendors-files-tab
                  :selectedRow="selectedRow"/>
              </el-tab-pane>
              <el-tab-pane  v-else :label="$t('vendors_tab_files')" name="vendorPersonFiles">
                <vendors-persons-files-tab
                  :selectedRow="selectedRow"/>
              </el-tab-pane>
              <el-tab-pane v-if="selectedRow.type === 'vendor'" :label="$t('project_tab_comments')" name="vendorComment">
                <vendor-comment ref="vendorComment" :selectedRow="selectedRow"/>
              </el-tab-pane>
              <el-tab-pane v-else disabled :label="$t('project_tab_comments')" name="vendorPersonsComment"></el-tab-pane>
               <el-tab-pane disabled label="Messages" name="messages"></el-tab-pane>
              <el-tab-pane v-if="selectedRow.type === 'vendor'" label="Meetings" name="vendorMeetings">
                <vendor-meetings ref="vendorMeetings"/>
              </el-tab-pane>
              <el-tab-pane v-else label="Meetings" name="vendorPersonsMeetings">
                <vendor-persons-meetings ref="vendorPersonsMeetings"/>
              </el-tab-pane>
              <!-- <el-tab-pane :label="$t('vendors_tab_mgt')" name="supplyChainTab">
                <SupplyChainTab/>
              </el-tab-pane>
              <el-tab-pane :label="$t('vendors_tab_accountTHINK')" name="accountTHINK">
                <AccountThinkTab/>
              </el-tab-pane> -->
              <el-tab-pane disabled label="SCM" name="scm">
                <!-- TODO -->
              </el-tab-pane>
              <el-tab-pane label="TF Accounting" name="at">
                <vendorAT ref="vendorAT" :selectedRow="selectedRow"/>
              </el-tab-pane>
              <el-tab-pane disabled label="Compliance" name="compliance">
                <!-- TODO -->
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>

        <sweet-modal blocking :title="$t('modal_vendor_address')" ref="address" class="modal">
          <iframe width="100%" height="400px" id="gmap_canvas" :src="map" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
        </sweet-modal>

        <sweet-modal blocking width="500" title="Assign Business Unit" ref="modalAddToBu" class="modal" v-on:close="closeModal">
          <el-select v-model="businessUnitsIdArr" placeholder="Business Unit" multiple style="width: 100%; margin-bottom: 20px;">
            <el-option v-for="item in businessUnitsList"
              :disabled="item.exist"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>

          <div class="modal__btn">
            <el-button @click="modalCancel('modalAddToBu')">{{$t('general_cancel')}}</el-button>
            <el-button :disabled="businessUnitsIdArr.length === 0" @click="submitForm()" type="primary">{{$t('general_submit')}}</el-button>
          </div>
        </sweet-modal>

      </div>
    </div>

    <sweet-modal blocking title="Import Vendors" width="700" ref="importVendors" class="modal">
      <!-- <el-row :gutter="20" style="margin-bottom: 20px;">
        <el-col :span="8" :offset="0">
          <div style="margin-bottom: 10px;">countryId</div>
          <el-select no-data-text="no data" v-model="mainCountryId" @visible-change="loadMainCountryList" :placeholder="$t('modal_country')" size="small" filterable style="width: 100%;">
            <el-option
              v-for="item in mainCountryList"
              :key="item.id"
              :label="`${item.name} (id: ${item.id})`"
              :value="item.id"
              @click.native="setState('main', item)">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8" :offset="0">
          <div style="margin-bottom: 10px;">stateId</div>
          <el-select no-data-text="no data" v-model="mainStateId" @visible-change="loadMainStateList" :placeholder="$t('modal_state')" size="small" filterable style="width: 100%;">
            <el-option
              v-for="item in mainStateList"
              :key="item.id"
              :label="`${item.name} (id: ${item.id})`"
              :value="item.id"
              @click.native="setCity('main', item)">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8" :offset="0">
          <div style="margin-bottom: 10px;">cityId</div>
          <el-select no-data-text="no data" v-model="mainCityId" @visible-change="loadMainCityList" :placeholder="$t('modal_city')" size="small" filterable style="width: 100%;">
            <el-option
              v-for="item in mainCityList"
              :key="item.id"
              :label="`${item.name} (id: ${item.id})`"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
      </el-row>

      <el-row v-if="directoriesForImport" :gutter="20" style="margin-bottom: 20px;">
        <el-col :span="8" :offset="0">
          <div style="margin-bottom: 10px;">companyTypeId</div>
          <el-select v-model="companyTypeId" size="mini" :placeholder="$t('modal_product_or_service')" clearable filterable style="width: 100%;">
            <el-option v-for="item in directoriesForImport.serviceTypesList"
              :key="item.id"
              :label="`${item.name} (id: ${item.id})`"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8" :offset="0">
          <div style="margin-bottom: 10px;">currencyId</div>
          <el-select v-model="currencyId" size="mini" :placeholder="$t('modal_currency')" style="width: 100%;" filterable>
            <el-option v-for="item in directoriesForImport.currenciesList"
              :key="item.id"
              :label="`${item.code} (id: ${item.id})`"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8" :offset="0">
          <div style="margin-bottom: 10px;">saleTaxId</div>
          <el-select v-model="saleTaxId" size="mini" :placeholder="$t('modal_tax_type_vat')" clearable filterable style="width: 100%;">
            <el-option v-for="item in directoriesForImport.inputTaxSubAccounts"
              :key="item.id"
              :label="`${item.name} (id: ${item.id})`"
              :value="item.id"
              @click.native="setTaxCode('taxCode', item)">
            </el-option>
          </el-select>
        </el-col>
      </el-row> -->

      <p>Download the tamplate file and follow instruction from first Sheet</p>

      <div style="margin-bottom: 20px;">
        <a :href="downloadURL" download>Download template XLS</a>
      </div>

      <form class="importVendors">
        <label for="fileImport" class="importVendors__label">
          <i class="el-icon-upload"></i> {{$t('modal_uploadFile')}}
        </label>
        <input v-show="false" @change="handleFileImport" ref="fileImport" id="fileImport" name="myFileImport" type="file">
      </form>
    </sweet-modal>

    <InviteVendor ref="modal"/>
    <AddVendorForm ref="modal11" :directories="directories" @selected="selected"/>
    <EditVendorForm ref="modal22" :directories="directories" :companyVendorsItem="companyVendorsItem" @selected="selected"/>
    <AddPerson ref="modal3" :directories="personsDirectories" @selected="selected"/>
    <EditPerson ref="modal4" :directories="personsDirectories" :companyVendorsPersonsItem="companyVendorsPersonsItem" @selected="selected"/>
  </div>
</template>

<script>
import moment from 'moment'
import InviteVendor from '@/components/vendors/InviteVendor.vue'
import AddVendorForm from '@/components/vendors/AddVendorForm2.vue'
import EditVendorForm from '@/components/vendors/EditVendorForm.vue'
import SupplyChainTab from '@/components/vendors/SupplyChainTab.vue'
import AccountThinkTab from '@/components/vendors/AccountThinkTab.vue'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import {AgGridVue} from "ag-grid-vue"
import axios from 'axios'
import resize from 'vue-resize-directive'
import AddPerson from "../components/vendors/AddPerson";
import EditPerson from '@/components/vendors/EditPerson.vue'
import VendorsFilesTab from "../components/vendors/VendorsFilesTab";
import VendorsPersonsFilesTab from "../components/vendors/VendorsPersonsFilesTab";
import VendorComment from "@/components/vendors/VendorComment.vue"
import VendorMeetings from "@/components/vendors/VendorMeetings.vue"
import VendorPersonsMeetings from "@/components/vendors/VendorPersonsMeetings.vue"
import vendorAT from "@/components/vendors/VendorAT.vue"
export default {
  name: 'vendors',
  directives: {
    resize
  },
  components: {
    VendorsPersonsFilesTab,
    VendorsFilesTab,
    AddPerson,
    EditPerson,
    InviteVendor,
    AddVendorForm,
    EditVendorForm,
    AgGridVue,
    SweetModal,
    SupplyChainTab,
    AccountThinkTab,
    VendorComment,
    VendorMeetings,
    VendorPersonsMeetings,
    vendorAT,
  },
  created() {
    this.$store.dispatch('getRowDataVendors')
  },
  computed: {
    rowData() {
      return this.$store.getters.getRowDataVendors
    },
    companyLayout() {
      return this.$store.state.companyLayout
    }
  },
  data() {
    return {
      directoriesForImport: null,
      downloadURL: null,

      mainCountryId: null,
      mainCountryList: [],
      mainStateId: null,
      mainStateList: [],
      mainCityId: null,
      mainCityList: [],

      companyTypeId: null,
      currencyId: null,
      saleTaxId: null,

      businessUnitsList: [],
      businessUnitsIdArr: [],
      map: '',
      map1: '',
      map2: '',
      map3: '',
      moment:moment,
      activeName: 'info',
      detailsVendors: 'first',
      infoVendors: 'first',
      disabledBtn: false,
      selectedRow: {},

      directories: null,
      companyVendorsItem: null,

      info: {
        enableExpanded: false,
        // General
        id: '',
        name: '',
        shortName: null,
        email: '',
        website: '',
        phone: '',
        linkedIn: '',
        facebook: '',
        fax: '',
        assignSupplyChainMgr: '',
        shippingMethod: '',
        tagAs: '',

        firstname: null,
        lastname: null,
        skype: null,
        workPhone: null,
        mobilePhone: null,

        addresses: null,
        // Address
        isAddressAssigned: false,

        country: null,
        state: null,
        city: null,
        address: '',
        address2: '',
        address3: '',
        postCode: '',

        finance: null,
        // Finance
        currencyId: null,
        creditLimit: null,
        paymentTerms: null,
        paymentTypes: null,
        bankName: null,
        bankAddress: null,
        SWIFTCode: null,
        accountName: null,
        branchSortCode: null,
        accountIBANNo: null,

        canvas: null,
        // Canvass
        ISOAccreditationNo: null,
        canvassSheet: null,
        manual: null,
        forms: null,
        spareParts: null,

        custom: null,
        // Custom
        customField1: null,
        customField2: null,
        customField3: null,
        customField4: null,
        customField5: null,
        customField6: null,

        // Tax Settings
        tax: null,

        expanded: null,
        // Expanded
        // --General
        expandedCountry: null,
        companyName: null,
        registrationSECNo: null,
        lineOfBusiness: null,
        RDOBarangay: null,
        region: null,
        // --General
        taxClassification: null,
        taxIdentificationNo: null,
        productOrService: null,
        taxType: null,
        taxCode: null,
        applyWithholdingTax: null,
      },

      businessUnitList: [],
      engagementList: [],
      projectList: [],

      // Tree
      gridOptions: null,
      gridApi: null,
      columnApi: null,
      getRowHeight:null,
      columnDefs: null,
      defaultColDef: null,
      rowSelection: null,
      personsDirectories: null,
      getDataPath: null,
      getRowNodeId: null,
      autoGroupColumnDef: null,
      groupDefaultExpanded: null,
      companyVendorsPersonsItem: null
    }
  },
  beforeMount() {
    this.gridOptions = {
      suppressCellSelection: true,
      overlayNoRowsTemplate: this.$i18n.t('general_noRowsToShow'),
    };
    this.columnDefs = [
      {
        // headerName: this.$i18n.t('vendors_id'),
        headerName: '#',
        field: "id",
        filter: false,
        headerClass: 'id-column',
        width: 12,
        cellRenderer: function(params) {
          return `<span class="txtRender">${ params.node.data.type === 'vendor' ? params.node.data.id : '' }</span>`
        },
        cellStyle: function(params) {
          return {'text-align': 'left; display: flex; justify-content:flex-start; padding-left: 10px;'}
        }
      },
      // { field: this.$i18n.t('vendors_name'),
      //   filter: "agTextColumnFilter",
      //   cellRenderer: function(params) {
      //     return `<span class="txtRender">${params.node.data.name}</span>`
      //   },
      //   cellStyle: function(params) {
      //     return {'text-align': 'center; display: flex;'}
      //   }
      // },
      // { field: this.$i18n.t('vendors_email'),
      //   filter: false,
      //   cellRenderer: function(params) {
      //     return `<span class="txtRender">${params.node.data.email}</span>`
      //   },
      //   cellStyle: function(params) {
      //     return {'text-align': 'center; display: flex;'}
      //   }
      // },
      // { field: this.$i18n.t('vendors_phone'),
      //   filter: false,
      //   cellRenderer: function(params) {
      //   if(params.node.data.phone){
      //     return `<span class="txtRender">${params.node.data.phone}</span>`
      //   }
      //   },
      //   cellStyle: function(params) {
      //     return {'text-align': 'center; display: flex;'}
      //   }
      // },
      // { field: this.$i18n.t('vendors_dateCreated'),
      //   filter: false,
      //   cellRenderer: function(params) {
      //     return `<span class="txtRender">${params.node.data.dateCreated}</span>`
      //   },
      //   cellStyle: function(params) {
      //     return {'text-align': 'center; display: flex;'}
      //   }
      // }
    ];
    this.getRowHeight = params => {
      return 40;
    };
    this.defaultColDef = {
      suppressMovable: true,
      suppressMenu: true,
      resizable: true,
      width: 150,
      filter: true,
      floatingFilter: true,
      sortable: true
    };
    this.rowSelection = "single"
    this.groupDefaultExpanded = -1;
    this.getDataPath = data => {
      return data.filePath
    }
    this.getRowNodeId = data => {
      return data.id
    }
    this.autoGroupColumnDef = {
      filter: 'agTextColumnFilter',
      headerName: 'Name (Vendor / Vendor Contact)',
      field: 'name',
      cellRendererParams: {
        suppressCount: true,
        // innerRenderer: "fileCellRenderer"
        // innerRenderer: "txtRenderer"
        innerRenderer: function(params) {
          return `<span class="txtRender">${params.node.data.name || params.node.data.fullName}</span>`
        }
      },
      cellStyle: function(params) {
        return {'text-align': 'center; display: flex;'}
      },
      cellClass: 'name-cell'
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
    this.gridApi.sizeColumnsToFit();
    this.gridApi.hidePopupMenu();
    this.gridColumnApi.moveColumn("id", 0);
  },
  methods: {
    async getDirectories() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .get(`/api/v1/client-vendor/directories?companyId=${this.$route.query.companyId}&type=vendor&countryId=${this.companyLayout.countryId}`)
        .then(response => {
          console.log('client-vendor/directories', response.data);
          this.directoriesForImport = response.data.list
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        });
    },
    async getURL() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .get(`/api/v1/client-vendor/directories-for-import?companyId=${this.$route.query.companyId}&type=vendor`)
        .then(response => {
          this.downloadURL = response.data.downloadPath
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        });
    },
    loadList(type, id, arrType) {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .get(`/api/v1/country/directories?type=${type}&id=${id}`)
        .then(response => {
          this[arrType] = response.data.list
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        });
    },
    // Main Address
    loadMainCountryList(isVisiable) {
      if (isVisiable && this.mainCountryList.length < 2) {
        this.loadList('country', null, 'mainCountryList')
      }
    },
    loadMainStateList(isVisiable) {
      if (isVisiable && this.mainStateList.length < 2) {
        this.loadList('state', this.mainCountryId, 'mainStateList')
      }
    },
    loadMainCityList(isVisiable) {
      if (isVisiable && this.mainCityList.length < 2) {
        this.loadList('city', this.mainStateId, 'mainCityList')
      }
    },
    setState(type, item) {
      if (type === 'main') {
        this.mainStateId = null;
        this.mainCityId = null;
        this.mainStateList = []
        this.mainCityList = []
      }
    },
    setCity(type, item) {
      if (type === 'main') {
        this.mainCityId = null
        this.mainCityList = []
      }
    },
    handleFileImport(e) {
      // TODO:
      var formData = new FormData();
      formData.append('file', e.target.files[0]);

      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/client-vendor/import?companyId=${this.$route.query.companyId}&entityType=vendor`, formData)
        .then(response => {
          this.notification("Success", "File upload", "success")
          this.$refs.fileImport.value = ''
          this.$store.dispatch('getRowDataVendors')
          this.$refs.importClients.close()
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          this.$refs.fileImport.value = ''
          loader.hide()
        });
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    openMap() {
      let address = this.info.country + ',' +  this.info.state + ',' +  this.info.city
      if (this.info.address) {
        address = address + ',' + this.info.address
      }
      if (this.info.address2 > 0) {
        address = address + ',' + this.info.address2
      }
      if (this.info.address3.length > 0) {
        address = address + ',' + this.info.address3
      }
      this.map = 'https://maps.google.com/maps?q=' + address + '&t=&z=13&ie=UTF8&iwloc=&output=embed'
      this.$refs['address'].open()
    },
    link(id) {
      localStorage.setItem('selectedProjectId', id)
      this.$router.push(`/projects?companyId=${this.$route.query.companyId}&projectId=${id}`);
    },
    linkTask(id, taskId) {
      localStorage.setItem('selectedProjectId', id)
      this.$router.push(`/projects?companyId=${this.$route.query.companyId}&projectId=${id}&taskId=${taskId}`);
    },
    linkBU(id) {
      localStorage.setItem('selectedBusinessUnitId', id)
      this.$router.push(`/business-units?companyId=${this.$route.query.companyId}&businessUnitId=${id}`);
    },
    linkBUTask(id, taskId) {
      localStorage.setItem('selectedBusinessUnitId', id)
      this.$router.push(`/business-units?companyId=${this.$route.query.companyId}&businessUnitId=${id}&taskId=${taskId}`);
    },
    linkE(id) {
      localStorage.setItem('selectedEngagementId', id)
      this.$router.push(`/engagements?companyId=${this.$route.query.companyId}&engagementId=${id}`);
    },
    linkETask(id, taskId) {
      localStorage.setItem('selectedEngagementId', id)
      this.$router.push(`/engagements?companyId=${this.$route.query.companyId}&engagementId=${id}&taskId=${taskId}`);
    },
    onResizePage(val){
      this.gridApi.sizeColumnsToFit()
    },
    async handleCommand(command){
      console.log('this', this.rowData)
      console.log('command', command)
      switch (command) {
        case 'addVendor':
          this.addVendor()
          break;
        case 'editVendor':
          this.editVendor()
          break;
        case 'deleteVendor':
          this.deleteVendor()
          break;
        case 'addContact':
          this.addPerson()
          break;
        case 'editContact':
          this.editPerson()
          break;
        case 'deleteContact':
          this.deletePerson()
          break;
        case 'addToBu':
          this.openModalAddToBu()
          break;
        case 'importVendors':
          await this.getDirectories()
          await this.getURL()
          this.$refs.importVendors.open()
          break;
        default:
      }
    },
    async openModalAddToBu() {
      const { data } = await axios.get(`/api/v1/businessUnits/cv/list?entityType=vendor&entityId=${this.selectedRow.vendorId}&companyId=${this.$route.query.companyId}`)
      this.businessUnitsList = data.list
      this.$refs.modalAddToBu.open()
    },
    modalCancel(ref) {
      this.$refs[ref].close();
    },
    submitForm() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .post(`/api/v1/client-vendor/add-to-bu?entityType=vendor`, {
          id: this.selectedRow.vendorId,
          buId: this.businessUnitsIdArr
        })
        .then(response => {
          this.$store.dispatch('getRowDataVendors')
          this.$refs.modalAddToBu.close()
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        });
    },
    closeModal() {
      this.businessUnitsList = []
      this.businessUnitsIdArr = []
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    inviteVendor() {
      console.log('---', 'inviteVendor');
      this.$refs['modal'].$refs['inviteVendor'].open()
    },
    openDialog(){
      this.$emit('openChat2')
    },
    addVendor() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .get(`/api/v1/client-vendor/directories?companyId=${this.$route.query.companyId}&type=vendor&countryId=${this.companyLayout.countryId}`)
        .then(response => {
          console.log('client-vendor/directories', response.data);
          this.directories = response.data.list
          this.$refs['modal11'].openModal()

          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        });
    },
    editVendor() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .get(`/api/v1/client-vendor?companyId=null&entityType=vendor&id=${this.selectedRow.vendorId}`)
        .then(response => {
          console.log('---/companyVendors/item', response.data);
          this.companyVendorsItem = response.data.result[0]

          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/client-vendor/directories?companyId=${this.$route.query.companyId}&type=vendor&countryId=${this.companyLayout.countryId}`)
            .then(response => {
              console.log('---/companyVendors/directories', response.data);
              this.directories = response.data.list
              this.$refs['modal22'].openModal()
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
            // loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        });
    },
    deleteVendor() {
      this.$confirm('This will permanently delete the vendor. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'info'
      }).then(() => {
        this.$message({
          type: 'success',
          message: 'Delete completed'
        });

        console.log('---', 'deleteVendor');
        let selectedRows = this.gridApi.getSelectedRows();
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .get(`/api/v1/client-vendor/delete?entityType=vendor&id=${this.selectedRow.vendorId}`)
            .then(response => {
                this.$store.dispatch('getRowDataVendors')
                this.$store.dispatch('getMenuStatistics')
                this.notification("Success", "Delete Vendor", "success")
                loader.hide()
            })
            .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
            });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        });
      });
    },
    deletePerson() {
      this.$confirm('This will permanently delete the contact. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'info'
      }).then(() => {
        this.$message({
          type: 'success',
          message: 'Delete completed'
        });

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/companyVendorPersons/delete?companyId=${this.$route.query.companyId}&companyVendorId=${this.$route.query.companyVendorId}&companyVendorPersonId=${this.$route.query.companyVendorPersonId}`)
            .then(response => {
              this.$store.dispatch('getRowDataVendors')
              this.$store.dispatch('getMenuStatistics')
              this.notification("Success", "Delete Persons", "success")
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        });
      });
    },
    selected(id) {
      var selectedId = id
      if (selectedId) {
        setTimeout(() => {
          this.selectCreatedTask(selectedId)
        }, 2000);
      } else {
        setTimeout(() => {
          this.selectCreatedTask(this.selectedRow.vendorId)
        }, 2000);
      }
    },
    selectCreatedTask(id){
      this.gridApi.forEachNode(function (node) {
        console.log("NODE DATA", node.data.vendorId)
        console.log("NODE DATA ID COMPARE", id)
        if (node.data.vendorId === id) {
          node.setSelected(true);
          console.log("NODE SELECTED")
        }
      });
    },
    onBtSuppressRowDrag() {
      this.gridApi.setSuppressRowDrag(true);
    },
    onBtShowRowDrag() {
      this.gridApi.setSuppressRowDrag(false);
    },
    onGridReady(params) {
      setTimeout(() => {
        if (this.rowData.length) {
          this.selectRow(0)
        }
      }, 1500)
    },
    selectRow(indexArg) {
      return new Promise ((resolve, reject) => {
        this.gridApi.forEachNode((node, index) => {
          if (index === indexArg) {
            this.gridApi.ensureIndexVisible(node.rowIndex, 'middle')
            node.setSelected(true)
            resolve(node)
          }
        })
      })
    },
    onSelectionChanged() {
      this.activeName = 'info'
      this.detailsVendors = 'first'
      this.infoVendors = 'first'
      // check if really row selected or deselectAll()
      if (!this.gridApi.getSelectedRows().length) return;

      var selectedRows = this.gridApi.getSelectedRows();
      this.selectedRow = selectedRows[0];
      console.log('---this.selectedRow[0].vendorId', this.selectedRow.vendorId);

      if (this.selectedRow.type === 'vendor') {
        switch (this.activeName) {
          case 'vendorPersonFiles':
            this.activeName = 'vendorFiles'
            break;
        }
      }

      if (this.selectedRow.type === 'person') {
        switch (this.activeName) {
          case 'vendorFiles':
            this.activeName = 'vendorPersonFiles'
            break;
        }
      }

      this.disabledBtn = true;
      console.log('---ROW', selectedRows);

      // General
      // vendor
      this.info.id = selectedRows[0].vendorId;
      this.info.name = selectedRows[0].name;
      this.info.shortName = selectedRows[0].shortName;
      this.info.email = selectedRows[0].email;
      this.info.website = selectedRows[0].website;
      this.info.linkedIn = selectedRows[0].linkedIn;
      this.info.facebook = selectedRows[0].facebook;
      this.info.phone = selectedRows[0].phone;
      this.info.fax = selectedRows[0].fax;
      this.info.assignSupplyChainMgr = selectedRows[0].assignSupplyChainMgr;
      this.info.shippingMethod = selectedRows[0].shippingMethod;
      this.info.tagAs = selectedRows[0].tagAs;

      // person
      this.info.firstname = selectedRows[0].firstname
      this.info.primaryContact = selectedRows[0].primaryContact
      this.info.position = selectedRows[0].position
      this.info.department = selectedRows[0].department
      this.info.lastname = selectedRows[0].lastname
      this.info.skype = selectedRows[0].skype
      this.info.workPhone = selectedRows[0].workPhone
      this.info.mobilePhone = selectedRows[0].mobilePhone

      this.info.country = selectedRows[0].country
      this.info.state = selectedRows[0].state
      this.info.city = selectedRows[0].city
      this.info.postCode = selectedRows[0].postCode
      this.info.address = selectedRows[0].addressLine1
      this.info.address2 = selectedRows[0].addressLine2
      this.info.address3 = selectedRows[0].addressLine3

      if (this.selectedRow.type === 'vendor') {
        this.$router.push(`/vendors?companyId=${this.$route.query.companyId}&companyVendorId=${selectedRows[0].vendorId}`);
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .get(`/api/v1/client-vendor?companyId=null&entityType=vendor&id=${selectedRows[0].vendorId}`)
          .then(response => {
            // Address
            this.info.addresses = response.data.result[0].addresses

            // Finance
            this.info.finance = response.data.result[0].finance

            // Canvass
            this.info.canvas = response.data.result[0].canvas

            // Custom
            this.info.custom = response.data.result[0].custom

            this.info.enableExpanded = response.data.result[0].enableExpanded

            // Tax Settings
            this.info.tax = response.data.result[0].tax

            // Expanded
            this.info.expanded = response.data.result[0].expanded

            this.businessUnitList = response.data.result[0].entityData.businessUnitList
            this.engagementList = response.data.result[0].entityData.engagementList
            this.projectList = response.data.result[0].entityData.projectList

            this.map1 = `https://maps.google.com/maps?q=${this.info.addresses.mainAddress.country.name},${this.info.addresses.mainAddress.state.name},${this.info.addresses.mainAddress.city.name}${this.info.addresses.mainAddress.postCode ? ',' + this.info.addresses.mainAddress.postCode : ''}${this.info.addresses.mainAddress.addressLines.addressLine1 ? ',' + this.info.addresses.mainAddress.addressLines.addressLine1 : ''}${this.info.addresses.mainAddress.addressLines.addressLine2 ? ',' + this.info.addresses.mainAddress.addressLines.addressLine2 : ''}${this.info.addresses.mainAddress.addressLines.addressLine3 ? ',' + this.info.addresses.mainAddress.addressLines.addressLine3 : ''}&t=&z=13&ie=UTF8&iwloc=&output=embed`
            this.map2 = `https://maps.google.com/maps?q=${this.info.addresses.billingAddress.country.name},${this.info.addresses.billingAddress.state.name},${this.info.addresses.billingAddress.city.name}${this.info.addresses.billingAddress.postCode ? ',' + this.info.addresses.billingAddress.postCode : ''}${this.info.addresses.billingAddress.addressLines.addressLine1 ? ',' + this.info.addresses.billingAddress.addressLines.addressLine1 : ''}${this.info.addresses.billingAddress.addressLines.addressLine2 ? ',' + this.info.addresses.billingAddress.addressLines.addressLine2 : ''}${this.info.addresses.billingAddress.addressLines.addressLine3 ? ',' + this.info.addresses.billingAddress.addressLines.addressLine3 : ''}&t=&z=13&ie=UTF8&iwloc=&output=embed`
            this.map3 = `https://maps.google.com/maps?q=${this.info.addresses.shippingWarehouseAddress.country.name},${this.info.addresses.shippingWarehouseAddress.state.name},${this.info.addresses.shippingWarehouseAddress.city.name}${this.info.addresses.shippingWarehouseAddress.postCode ? ',' + this.info.addresses.shippingWarehouseAddress.postCode : ''}${this.info.addresses.shippingWarehouseAddress.addressLines.addressLine1 ? ',' + this.info.addresses.shippingWarehouseAddress.addressLines.addressLine1 : ''}${this.info.addresses.shippingWarehouseAddress.addressLines.addressLine2 ? ',' + this.info.addresses.shippingWarehouseAddress.addressLines.addressLine2 : ''}${this.info.addresses.shippingWarehouseAddress.addressLines.addressLine3 ? ',' + this.info.addresses.shippingWarehouseAddress.addressLines.addressLine3 : ''}&t=&z=13&ie=UTF8&iwloc=&output=embed`
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });

        // this.map1 = `https://maps.google.com/maps?q=${this.info.addresses.mainAddress.country.name},${this.info.addresses.mainAddress.state.name},${this.info.addresses.mainAddress.city.name}${this.info.addresses.mainAddress.postCode ? ',' + this.info.addresses.mainAddress.postCode : ''}${this.info.addresses.mainAddress.addressLines.addressLine1 ? ',' + this.info.addresses.mainAddress.addressLines.addressLine1 : ''}${this.info.addresses.mainAddress.addressLines.addressLine2 ? ',' + this.info.addresses.mainAddress.addressLines.addressLine2 : ''}${this.info.addresses.mainAddress.addressLines.addressLine3 ? ',' + this.info.addresses.mainAddress.addressLines.addressLine3 : ''}&t=&z=13&ie=UTF8&iwloc=&output=embed`
        // this.map2 = `https://maps.google.com/maps?q=${this.info.addresses.billingAddress.country.name},${this.info.addresses.billingAddress.state.name},${this.info.addresses.billingAddress.city.name}${this.info.addresses.billingAddress.postCode ? ',' + this.info.addresses.billingAddress.postCode : ''}${this.info.addresses.billingAddress.addressLines.addressLine1 ? ',' + this.info.addresses.billingAddress.addressLines.addressLine1 : ''}${this.info.addresses.billingAddress.addressLines.addressLine2 ? ',' + this.info.addresses.billingAddress.addressLines.addressLine2 : ''}${this.info.addresses.billingAddress.addressLines.addressLine3 ? ',' + this.info.addresses.billingAddress.addressLines.addressLine3 : ''}&t=&z=13&ie=UTF8&iwloc=&output=embed`
        // this.map3 = `https://maps.google.com/maps?q=${this.info.addresses.shippingWarehouseAddress.country.name},${this.info.addresses.shippingWarehouseAddress.state.name},${this.info.addresses.shippingWarehouseAddress.city.name}${this.info.addresses.shippingWarehouseAddress.postCode ? ',' + this.info.addresses.shippingWarehouseAddress.postCode : ''}${this.info.addresses.shippingWarehouseAddress.addressLines.addressLine1 ? ',' + this.info.addresses.shippingWarehouseAddress.addressLines.addressLine1 : ''}${this.info.addresses.shippingWarehouseAddress.addressLines.addressLine2 ? ',' + this.info.addresses.shippingWarehouseAddress.addressLines.addressLine2 : ''}${this.info.addresses.shippingWarehouseAddress.addressLines.addressLine3 ? ',' + this.info.addresses.shippingWarehouseAddress.addressLines.addressLine3 : ''}&t=&z=13&ie=UTF8&iwloc=&output=embed`
      } else {
        this.$router.push(`/vendors?companyId=${this.$route.query.companyId}&companyVendorId=${selectedRows[0].vendorId}&companyVendorPersonId=${selectedRows[0].personId}`);
        this.businessUnitList = selectedRows[0].businessUnitList
        this.engagementList = selectedRows[0].engagementList
        this.projectList = selectedRows[0].projectList

        this.map = `https://maps.google.com/maps?q=${this.info.country ? this.info.country.name : ''},${this.info.state ? this.info.state.name : ''},${this.info.city ? this.info.city.name : ''}${this.info.postCode ? ',' + this.info.postCode : ''}${this.info.address ? ',' + this.info.address : ''}${this.info.address2 ? ',' + this.info.address2 : ''}${this.info.address3 ? ',' + this.info.address3 : ''}&t=&z=13&ie=UTF8&iwloc=&output=embed`
      }

      // if (this.selectedRow.type === 'vendor') {
      //   this.$router.push(`/vendors?companyId=${this.$route.query.companyId}&companyVendorId=${selectedRows[0].vendorId}`);
      // } else {
      //   this.$router.push(`/vendors?companyId=${this.$route.query.companyId}&companyVendorId=${selectedRows[0].vendorId}&companyVendorPersonId=${selectedRows[0].personId}`);
      // }

      // getProjectList
      // let loader = this.$loading.show();
      // axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      // axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      // axios
      //     .post(`/api/v1/companyVendors/projectList?companyId=${this.$route.query.companyId}&companyVendorId=${this.$route.query.companyVendorId}`)
      //     .then(response => {
      //         console.log('---/companyVendors/projectList', response.data.projectList)

      //         let list = []
      //         for (let i = 0; i < response.data.projectList.length; i++) {
      //           let res = {
      //             id: '',
      //             no: '',
      //             name: '',
      //             createDate: '',
      //           }

      //           res.id = response.data.projectList[i].project.id
      //           res.no = response.data.projectList[i].project.no
      //           res.name = response.data.projectList[i].project.name
      //           res.createDate = moment(response.data.projectList[i].project.createDate * 1000).format("D MMM YY")

      //           list.push(res)
      //         }

      //         // this.projectList = list
      //         loader.hide()
      //     })
      //     .catch(error => {
      //         console.log('An error occurred:', error);
      //         loader.hide()
      //     });

      // getBusinessUnitList
      // axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      // axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      // axios
      //     .post(`/api/v1/companyVendors/businessUnitList?companyId=${this.$route.query.companyId}&companyVendorId=${this.$route.query.companyVendorId}`)
      //     .then(response => {
      //         let list = []
      //         for (let i = 0; i < response.data.businessUnitList.length; i++) {
      //           let res = {
      //             id: '',
      //             no: '',
      //             name: '',
      //             createDate: '',
      //           }

      //           res.id = response.data.businessUnitList[i].businessUnit.id
      //           // res.no = response.data.businessUnitList[i].businessUnit.no
      //           res.name = response.data.businessUnitList[i].businessUnit.name
      //           res.createDate = moment(response.data.businessUnitList[i].businessUnit.createDate * 1000).format("D MMM YY")
      //           list.push(res)
      //         }
      //         // this.businessUnitList = list
      //     })
      //     .catch(error => {
      //         console.log('An error occurred:', error);
      //     });

      // getEngagementList
      // axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      // axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      // axios
      //     .post(`/api/v1/companyVendors/engagementList?companyId=${this.$route.query.companyId}&companyVendorId=${this.$route.query.companyVendorId}`)
      //     .then(response => {
      //         let list = []
      //         for (let i = 0; i < response.data.engagementList.length; i++) {
      //           let res = {
      //             id: '',
      //             no: '',
      //             name: '',
      //             createDate: '',
      //           }

      //           res.id = response.data.engagementList[i].engagement.id
      //           // res.no = response.data.engagementList[i].engagement.no
      //           res.name = response.data.engagementList[i].engagement.name
      //           res.createDate = moment(response.data.engagementList[i].engagement.createDate * 1000).format("D MMM YY")
      //           list.push(res)
      //         }
      //         // this.engagementList = list
      //     })
      //     .catch(error => {
      //         console.log('An error occurred:', error);
      //     });

      switch (this.activeName) {
        case 'vendorFiles':
          this.$store.dispatch('getVendorsFiles')
          break;
        case 'vendorPersonFiles':
          this.$store.dispatch('getVendorsPersonsFiles')
          break;
      }
    },
    addPerson() {
      this.$refs['modal3'].$refs['addPerson'].open()
    },
    editPerson() {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .post(`/api/v1/companyVendorPersons/item?companyId=${this.$route.query.companyId}&companyVendorId=${this.$route.query.companyVendorId}&companyVendorPersonId=${this.$route.query.companyVendorPersonId}`)
        .then(response => {
          console.log('---/companyVendorPersons/item', response.data);
          this.companyVendorsPersonsItem = response.data.item
          this.$refs['modal4'].openModal()
        })
        .catch(error => {
          console.log('An error occurred:', error);
        });
    },
    handleClick(tab, event) {
      if(tab.name === 'vendorFiles'){
        this.$store.dispatch('getVendorsFiles')
      } else if (tab.name ==='vendorPersonFiles') {
        this.$store.dispatch('getVendorsPersonsFiles')
      } else if (tab.name === 'vendorComment') {
        this.$refs['vendorComment'].loadList()
      } else if (tab.name === 'vendorMeetings') {
        this.$refs['vendorMeetings'].loadList()
      } else if (tab.name === 'vendorPersonsMeetings') {
        this.$refs['vendorPersonsMeetings'].loadList()
      } else if (tab.name === 'at') {
        this.$refs['vendorAT'].openTab()
      }
    }
  },
  watch: {
    rowData(val){
      if (val.length === 0) {
        this.disabledBtn = true
      }else{
        this.disabledBtn = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.vendors {
  background: #DfE8F0;
  height: 100vh;
}

.content {
  display: flex;
  height: 100vh;
  padding-top: 50px;
}

.wrap {
  display: flex;
  width: 100%;
  padding: 20px 10px 10px 10px;

  &__tree {
    width: 35%;
    padding: 0 10px 10px 0;
  }
  &__info {
    display: flex;
    flex-direction: column;
    width: 65%;
    padding: 0 0 0 10px;
  }
  &__info-tab {
    height: 100%;
    margin-top: 0px;
    overflow-y: auto;
    .isEmpty {
      color: #ccc
    }
    &_label {
      display: inline-block;
      width: 200px;
    }
    ul {
      margin: 0;
      padding: 0;
      list-style: none;
      color: #888;
      li {
        margin-bottom: 8px;
        span {
          font-weight: 500;
        }
      }
    }
  }
}

.nav-tree {
  padding-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  h3 {
    margin: 0;
  }
  &__item {
    margin: 0 0 5px 0;
  }
  .el-button {
    margin-right: 10px;
  }
}

/deep/.ag-theme-balham .ag-header-cell, .ag-theme-balham .ag-header-group-cell{
  padding-left:0;
}

.button{
  cursor: pointer;
}

.el-tabs--border-card {
  height: 100%;
  overflow-x: hidden;
  /deep/.el-tabs__content {
    height: 100% !important;
  }
}

.importVendors {
  width: 100%;
  &__label {
    width: 100%;
    color: #409EFF;
    padding: 7px 15px;;
    border: 1px solid #b3d8ff;
    border-radius: 3px;
    cursor: pointer;
    &:hover {
      background: #409EFF;
      border-color: #409EFF;
      color: #FFF;
    }
  }
}
</style>
